import React from "react";

import { Button } from "@material-ui/core";
import ReplayIcon from "@material-ui/icons/Replay";

import ColorPickerField from "./ColorPickerField";
import TemplateBgSelector from "./TemplateBgSelector";
import ThemeListCollection from "./ThemeListCollection";

import { AppearanceConfig } from "../../../../constants";
import style from "../../style.module.css";

export const ThemeColors = (props) => {
  const {
    setState,
    state,
    initialState,
    setField,
    disableAllEdits,
    templateData,
  } = props;

  return (
    <div className={style.fieldContainer}>
      <div className={`${style.info} tw-my-[6px]`}>
        Customize the colors across your website or use one of the preset color
        palettes.
      </div>
      <ThemeListCollection
        themeList={templateData.themes.filter(
          (theme) => Object.values(theme?.color_codes).length
        )}
        themeSlug={state.themeSlug}
        setThemeSlug={(v) => setField("themeSlug", v)}
        disableAllEdits={disableAllEdits}
      />
      <hr />
      {Object.values(
        disableAllEdits ? {} : state?.theme?.codes?.categories || {}
      )
        .sort((a, b) => a.order - b.order)
        .map((c) => {
          const getColorVal = (colorKeyProp) =>
            state?.colors?.[colorKeyProp] ||
            state?.theme?.codes?.colors?.[colorKeyProp] ||
            "0, 0, 0";
          return (
            <React.Fragment key={JSON.stringify(c.data)}>
              <div className={style.themeFieldGroupTitle}>{c.title}</div>
              {c.data?.map((colorKey) => (
                <ColorPickerField
                  key={colorKey}
                  label={
                    state.theme?.codes?.labels?.[colorKey] ||
                    // replaceAll is unavailable in old browsers so this is used
                    `${colorKey.split("-").join(" ")}`
                  }
                  colorKey={colorKey}
                  getColorVal={getColorVal}
                  setColor={(v) => setField(["colors", colorKey], v)}
                />
              ))}
            </React.Fragment>
          );
        })}

      {AppearanceConfig.showBgSelector.includes(templateData.slug) &&
      !disableAllEdits ? (
        <TemplateBgSelector
          state={state}
          setField={setField}
          template={templateData.slug}
          disableAllEdits={disableAllEdits}
        />
      ) : null}

      <hr />
      <div className={style.resetButtonContainer}>
        <Button
          color="secondary"
          title="Reset changes to the theme colors"
          disabled={
            JSON.stringify(state.colors) ===
            JSON.stringify(initialState?.theme?.codes?.colors)
          }
          className={`${style.button} ${style.resetButton}`}
          onClick={() => {
            setState({
              ...state,
              colors: state?.theme?.codes?.colors,
              reset_colors: true,
            });
          }}
        >
          <ReplayIcon />
          Reset Colors
        </Button>
      </div>
    </div>
  );
};
